<template>
  <section class="bg-gray-200 py-12">
    <div class="max-w-6xl mx-auto px-6 text-center">
      <h2 class="text-xl font-semibold text-gray-700 mb-6">
        Trusted tools, platforms & communities I work with:
      </h2>

      <div
        class="flex flex-wrap items-center justify-center gap-8 fade-in-on-scroll"
        v-scroll-fade
      >
        <img src="@/assets/logos/tradingview.svg" alt="TradingView" class="h-10 object-contain" />
        <img src="@/assets/logos/pinescript.svg" alt="Pine Script" class="h-10 object-contain" />
        <img src="@/assets/logos/mt5.svg" alt="MetaTrader 5" class="h-10 object-contain" />
        <img src="@/assets/logos/telegram.svg" alt="Telegram" class="h-10 object-contain" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "LogoStrip",
};
</script>
